<div class="dark-mode">
    <div class="row my-3">
        <div class="col-12 col-sm-12 col-md-6">
            <h4 class="mt-3">Cyber Combine: Scorecard</h4>
            <div style="color: #979797">Input and manage user scores.</div>
        </div>

        <div class="col-12 col-sm-12 col-md-6 text-end">
            <button (click)="newScorecard()" class="mt-3 bg-accent-orange" mat-raised-button aria-label="add certification" >
                <mat-icon>add</mat-icon> Add New Scorecard
            </button>
        </div>
    </div>
    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap">Date</th>
                <th class="text-nowrap">Competition Level</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let s of scorecards">
                <td class="text-nowrap">{{ s.assessmentDate | date : "MM/dd/y" }}</td>
                <td class="text-nowrap">{{ s.competitionLevel }}</td>
                <td class="sticky-action" style="width: 80px;">
                    <div class="d-flex gap-4 justify-content-center">
                        <mat-icon class="accent-orange" (click)="editScorecard(s)">edit</mat-icon>
                        <mat-icon class="crimson-red" (click)="deleteScorecard(s)">delete</mat-icon>
                    </div>
                </td>
            </tr>
            <tr *ngIf="scorecards.length == 0">
                <td colspan="7" class="text-center">
                    <span>No assessment available </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="mt-4" *ngIf="scorecards.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>

